module.exports = __webpack_public_path__ + "img/family.04d62354.png";